import { Avatar, Button, Tooltip } from "antd";
import moment from "moment";
import Folder from "../../icons/Folder";
import Jeans from "../../icons/Jeans";
import { UserOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import "./style.css";
import { useEffect } from "react";
export default function TableRowDirectOrder({ item, url }: any) {
  return (
    <tr>
      {/*  <td>
        <ul id="myUL">
          <li>
            <span className="caret">{item.ref}</span>

            {item.articles && item.articles.length > 0 ? (
              <>
                {" "}
                <ul className="nested">
                  {item.articles.map((elm: any) => (
                    <>
                      <span className="caret">{elm.name}</span>
                      <ul className="nested">
                        {elm.options.map((e: any) => (
                          <>
                            <li className="nestedli" style={{ margin: "6px" }}>
                              <Link
                                to={`${url}/${item.id}/${elm.id}/${e.id}/progress`}
                              >
                                {e.name}
                              </Link>
                            </li>
                          </>
                        ))}
                      </ul>
                    </>
                  ))}
                </ul>
              </>
            ) : (
              <>
                {" "}
                <ul className="nested" style={{ color: "#7C7C7C" }}>
                  No subfolders
                </ul>
                <></>
              </>
            )}
          </li>
        </ul>
      </td> */}
      <td scope="row">
        {item.articles.length > 1 ? <Folder /> : <Jeans />}
        <span className="ml-2 myorder_order_name">{item.ref}</span>
      </td>
      <td scope="row">
        <span>{item.name}</span>
      </td>
      <td>{moment(item.updated_at).format("DD/MM/YYYY")}</td>
      <td>
        <Avatar.Group
          maxCount={2}
          size="large"
          maxStyle={{ color: "white", backgroundColor: "#7a9ec5" }}
        >
          {item.collaborators.map((collab: any) => (
            <Tooltip title={collab.name} key={collab.id} placement="bottom">
              {collab.logo ? (
                <Avatar
                  style={{
                    boxShadow: "1px 0px 5px rgba(0,0,0,0.4)",
                  }}
                  src={process.env.REACT_APP_STORAGE_URL + collab.logo}
                />
              ) : (
                <Avatar
                  style={{
                    backgroundColor: "#ddd",
                    boxShadow: "1px 0px 5px rgba(0,0,0,0.2)",
                  }}
                  icon={<UserOutlined style={{ verticalAlign: "2px" }} />}
                />
              )}
            </Tooltip>
          ))}
        </Avatar.Group>
      </td>
      <td>
        <p className="mb-0">
          {item.articles.length} article{item.articles.length > 1 ? "s" : ""}
        </p>
      </td>
      <td>
        <Link to={`${url}/${item.id}`}>
          <Button
            type="ghost"
            className="see_more_order_details_btn"
            style={{ height: "50px !important" }}
          >
            See More
          </Button>
        </Link>
      </td>
    </tr>
  );
}
